/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Imprintandprivacy2Inputs */



/**
* | output |
* | --- |
* | "Imprint &amp; Privacy Policy" |
*
* @param {Imprintandprivacy2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const imprintandprivacy2 = /** @type {((inputs?: Imprintandprivacy2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Imprintandprivacy2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Imprint &amp; Privacy Policy")
	return /** @type {LocalizedString} */ ("Impressum &amp; Datenschutz")
});
export { imprintandprivacy2 as "imprintAndPrivacy" }